import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import * as React from 'react';
const SvgStatusError = ({
  accessibilityText,
  forwardedRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  width: 24,
  height: 24,
  "aria-hidden": accessibilityText ? undefined : true,
  "aria-label": accessibilityText,
  fill: "currentColor",
  focusable: false,
  ref: forwardedRef,
  role: accessibilityText ? 'img' : undefined
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 3.9c4.47 0 8.1 3.63 8.1 8.1s-3.63 8.1-8.1 8.1-8.1-3.63-8.1-8.1S7.53 3.9 12 3.9M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m5 6.34L15.66 7 12 10.66 8.34 7 7 8.34 10.66 12 7 15.66 8.34 17 12 13.34 15.66 17 17 15.66 13.34 12z"
}));
export default SvgStatusError;